import { Component, OnInit } from '@angular/core';
import { VernostServiceService } from "../../../services/vernost-service.service";
@Component({
  selector: 'app-delta-data-upload',
  templateUrl: './delta-data-upload.component.html'
})
export class DeltaDataUploadComponent implements OnInit {
  screentitle: string = "Reschedule Data";
  upload_err: string = "*Note: Accepts only csv file format."
  selectedFile:any;
  fd = new FormData();
  loader = false;
  constructor(private vernostService: VernostServiceService) { }


  ngOnInit() {
  }
  fileChangeListener(val){
    var files = val.target.files[0]; // FileList object
    if (!this.vernostService.isCSVFile(files)){
      this.upload_err = "Please Select .csv file Format.";
    }else{
      this.upload_err = "";
      this.fd.append('file', files, files.name);
    }
  }
  uploadFile(){
    if(this.selectedFile != undefined && this.selectedFile != ''){
      this.loader = true;
      this.vernostService.uploadCreditShellCSV(this.fd).subscribe((res)=>{
        this.loader = false;
        if(res['status']){
          document.getElementById('upload_err_div').classList.remove('has-error');
          document.getElementById('upload_err_div').classList.add('has-success');
          this.selectedFile = '';
          this.upload_err = "File uploaded Successfully.";
        }else{
          document.getElementById('upload_err_div').classList.remove('has-success');
          document.getElementById('upload_err_div').classList.add('has-error');
          this.upload_err = "Something went wrong please try again.";
        }  
      })
    }else{
      document.getElementById('upload_err_div').classList.remove('has-success');
      document.getElementById('upload_err_div').classList.add('has-error');
      this.upload_err = "Please Select .csv file Format.";
    }
  }
  downloadSampleFile(){
    let link = document.createElement("a");
    link.download = "CREDIT_SHELL_SAMPLE.csv";
    link.href = "assets/csv/CREDIT_SHELL_SAMPLE.csv";
    link.click();
  }
  downloadSampleFileDC(){
    let link = document.createElement("a");
    link.download = "DATE_CHANGE_SAMPLE.csv";
    link.href = "assets/csv/DATE_CHANGE_SAMPLE.csv";
    link.click();
  }
}
